import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@material-ui/core';
import style from './style/downloadpdfbutton.scss';

/** DownloadPdfButton component
 *
 * @example
 * <DownloadPdfButton
 *    buttonLabel={ 'translated label' }
 *    getPdfReport={ parentMethodToBeCalledOnClick() }
 * />
 */
export default class DownloadPdfButton extends Component {
    render() {
        const { buttonLabel, loading, getPdfReport } = this.props;

        return (
            <button
                className={`action_button action_button__secondary modal ${style.download_pdf_button_wrapper}`}
                data-cy="download-pdf-button"
                disabled={loading}
                onClick={() => {
                    getPdfReport();
                }}
            >
                <span className={style.download_pdf_button_icon}>
                    {loading
                        ? <CircularProgress size={'1rem'} />
                        : <FontAwesomeIcon
                            className={style.download_pdf_button_icon}
                            icon={['far', 'file-pdf']}
                        />}
                </span>
                <p>{buttonLabel}</p>
            </button>
        );
    }
}
